import request from '@/utils/request';
import { calculateParams } from '@/utils/calculations';

/* eslint-disable */
const actions = {
  async getSkroutzOrders({ dispatch, commit, getters }, params = {}) {
    try {
      await commit('updateIsLoading', { isLoading: true });

      const newParams = calculateParams(getters['getPaginationParams'], {
        ...params,
      });

      await commit('setPaginationParams', newParams);

      const { data } = await request.get('/orders-skroutz', {
        params: newParams,
      });
      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('setData', data.orders);

      await commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      await commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },
};

export default actions;
